module.exports = __webpack_public_path__ + "img/BOX.a2f91b3f.svg";